import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageService } from '../services/page.service';
import { ClienteComponent } from '../../components/cliente/cliente.component';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-matriculacion',
  templateUrl: './matriculacion.component.html',
  styleUrls: ['./matriculacion.component.css'],
})
export class MatriculacionComponent implements OnInit, AfterContentChecked {
  @ViewChild('clienteComponent', { static: false }) cliente: ClienteComponent;
  datosVehiculos: FormGroup;
  documentos: FormGroup;
  isEditable = true;
  datoTramite: any;
  exencion: boolean;
  solicitud: string;
  observacion: any;
  provincias: any[];
  ocultar = true;
  clienteComprador: any;
  archivos: any[] = [];
  clasif: any;
  spinnerFirma: any;
  spinnerEITV = false;
  recuperadoEITV = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private fb: FormBuilder,
    private servicio: PageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.inicio();
  }

  ngAfterContentChecked(): void {
    this.cdRef.detectChanges();
  }

  get datosCliente(): any {
    return this.cliente ? this.cliente.cliente$ : null;
  }

  get bastidorNoValido(): any {
    return (
      this.datosVehiculos.get('bastidor').invalid &&
      this.datosVehiculos.get('bastidor').touched
    );
  }

  get marcaNoValido(): any {
    return (
      this.datosVehiculos.get('marca').invalid &&
      this.datosVehiculos.get('marca').touched
    );
  }

  get modeloNoValido(): any {
    return (
      this.datosVehiculos.get('modelo').invalid &&
      this.datosVehiculos.get('modelo').touched
    );
  }

  inicio(): void {
    this.solicitud = sessionStorage.getItem('id');
    sessionStorage.setItem('tipoCliente', '1');
    this.clasificaciones();
    this.getProvincia();
    if (sessionStorage.getItem('colaborador') === 'null') {
      this.router.navigate(['page/home']);
    }
    this.crearFormulario();
    if (this.solicitud !== 'null') {
      console.log('aca');
      this.getSolicitud();
    }
  }

  crearFormulario(): any {
    this.datosVehiculos = this.fb.group({
      tipo: '',
      colaborador: '',
      usuarioweb: '',
      tipoVehiculo: '10',
      servicioalquesedestina: 'B00 - PART-SIN ESPECIFICAR',
      exencion: '0',
      tipoexencion: '',
      renting: '0',
      solicitardistintivo: '0',
      bastidor: ['', [Validators.required]],
      marca: '',
      modelo: '',
      tipoImpositivo: '0',
      baseImponible: ['0.00', [Validators.required, Validators.min(1)]],
      cv: '',
      co2: ['0', [Validators.required, Validators.minLength(1)]],
      impuestoMatriculacion: '',
      importeTotalFactura: ['0', [Validators.required, Validators.min(1)]],
    });
  }

  getProvincia(): void {
    this.servicio.getProvincia().subscribe(
      async (res) => {
        console.log(res);
        this.provincias = await res;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getexencion(event): any {
    if (event === '1') {
      this.exencion = true;
    } else {
      if (event === '0') {
        this.exencion = false;
        this.datosVehiculos.controls.tipoexencion.setValue('');
      }
    }
    console.log(this.exencion);
  }

  siguiente(): void {
    this.datoTramite = {
      ...this.clienteComprador,
      ...this.datosVehiculos.value,
    };
    const c = this.clasif.find(
      (res) => res.id === this.datosVehiculos.value.tipoVehiculo
    );
    this.datoTramite.tipoVehiculo = c.descripcion;
    this.datoTramite.numPedido = sessionStorage.getItem('numPedido');
    this.datoTramite.tipo = sessionStorage.getItem('tipo');
    this.datoTramite.colaborador = sessionStorage.getItem('colaborador');
    this.datoTramite.usuarioweb = sessionStorage.getItem('email');
    this.datoTramite.km = sessionStorage.getItem('km');
    this.datoTramite.paisOrigen = sessionStorage.getItem('paisOrigen');
    console.log(this.datoTramite);
  }

  siguiente2($event: any): void {
    this.clienteComprador = $event;
  }

  getSolicitud(): void {
    this.servicio.getOneSolicitud(this.solicitud).subscribe(
      (res) => {
        this.setDatos(res);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getDatosEITV(): void {
    if (
      this.datosVehiculos.get('bastidor').value == '' ||
      this.datosVehiculos.get('bastidor').invalid
    ) {
      Swal.fire(
        '',
        'Se necesita un bastidor válido para recuperar los datos del vehículo desde la DGT',
        'warning'
      );
    } else {
      this.spinnerEITV = true;
      this.servicio
        .getEITV(this.datosVehiculos.get('bastidor').value)
        .subscribe({
          next: (value) => {
            console.log(value.content);
            if (value.error == 'ERROR')
              Swal.fire(
                '',
                'Error recuperando los datos: ' +
                  value.content +
                  '. Por favor rellene manualmente los datos.',
                'warning'
              );
            else {
              Swal.fire('', 'Datos EITV recuperados con éxito', 'success');
              this.datosVehiculos.controls.marca.setValue(
                value.content.datos.MARCA
              );
              this.datosVehiculos.controls.modelo.setValue(
                value.content.datos.MODELO
              );
              this.datosVehiculos.controls.co2.setValue(
                (parseInt(value.content.datos.EMISION_CO2) / 1000).toFixed(0)
              );
              this.datosVehiculos.controls.tipoVehiculo.setValue(
                value.content.datos.CLASIFICACION_VEHICULO.slice(0, 2)
              );
              this.calcularImpuesto();
              this.datosVehiculos.controls.cv.setValue(
                (parseInt(value.content.datos.POTENCIA_NETA) / 1000).toString()
              );
              //this.datosVehiculos.controls.cv.setValue((parseInt(value.content.datos.POTENCIA_NETA)/1000).toFixed(3).toString().padStart(13,"0"));
            }
          },
          error: (err) => {
            console.log(err);
            Swal.fire(
              '',
              'Imposible conectar con la DGT, por favor compruebe el bastidor y si es correcto rellene manualmente los datos del vehículo',
              'warning'
            );
          },
          complete: () => {
            this.spinnerEITV = false;
            this.recuperadoEITV = true;
          },
        });
    }
  }

  setDatos(datos): void {
    console.log(datos.tipoVehiculo);
    if (datos.tipoVehiculo !== null) {
      this.datosVehiculos.controls.tipoVehiculo.setValue(
        datos.tipoVehiculo?.trim().slice(0, 2)
      );
    } else {
      this.datosVehiculos.controls.tipoVehiculo.setValue(
        datos.tipoVehiculo?.trim() === '' ? '10' : datos.tipoVehiculo?.trim()
      );
    }
    if (
      datos.servicioalquesedestina === null ||
      datos.servicioalquesedestina === 'null' ||
      datos.servicioalquesedestina === 'NULL' ||
      // tslint:disable-next-line:max-line-length
      datos.servicioalquesedestina === '' ||
      datos.servicioalquesedestina === 'undefined' ||
      datos.servicioalquesedestina === 'UNDEFINED'
    ) {
      this.datosVehiculos.controls.servicioalquesedestina.setValue(
        'B00 - PART-SIN ESPECIFICAR'
      );
    } else {
      this.datosVehiculos.controls.servicioalquesedestina.setValue(
        datos.servicioalquesedestina
      );
    }
    const exencion = this.getRespuesta(datos.exencion);
    this.datosVehiculos.controls.exencion.setValue(exencion);
    this.datosVehiculos.controls.tipoexencion.setValue(datos.tipoexencion);
    const renting = this.getRespuesta(datos.renting);
    this.datosVehiculos.controls.renting.setValue(renting);
    const solicitardistintivo = this.getRespuesta(datos.solicitardistintivo);
    this.datosVehiculos.controls.solicitardistintivo.setValue(
      solicitardistintivo
    );
    this.datosVehiculos.controls.bastidor.setValue(datos.bastidor);
    this.datosVehiculos.controls.baseImponible.setValue(datos.baseImponible);
    this.datosVehiculos.controls.cv.setValue(datos.cv);
    this.datosVehiculos.controls.tipoImpositivo.setValue(datos.tipoImpositivo);
    this.datosVehiculos.controls.co2.setValue(datos.co2);
    this.datosVehiculos.controls.impuestoMatriculacion.setValue(
      datos.impuestoMatriculacion
    );
    this.datosVehiculos.controls.importeTotalFactura.setValue(
      datos.importeTotalFactura
    );
    sessionStorage.setItem('tipo', datos.tipo);
  }

  getRespuesta(condition): string {
    let v = '';
    switch (condition) {
      case false:
        v = '0';
        break;
      case true:
        v = '1';
        break;
    }
    return v;
  }

  calcularImpuesto(): void {
    let idProv = 0;
    this.provincias.map((p) => {
      if (p.nomprov.includes(this.clienteComprador.provincia)) {
        idProv = p.idprov;
      }
    });
    if (this.datosVehiculos.value.co2) {
      const impuesto = this.servicio.cacularImpositivo(
        this.datosVehiculos.value.tipoVehiculo,
        idProv,
        this.datosVehiculos.value.cv,
        this.datosVehiculos.value.co2
      );
      this.datosVehiculos.controls.tipoImpositivo.setValue(impuesto);
    }
    if (this.datosVehiculos.value.baseImponible) {
      this.impuestoMtriculacion();
    }
  }

  clasificacion(): void {
    switch (this.datosVehiculos.value.tipoVehiculo) {
      case '03':
      case '04':
        this.ocultar = false;
        this.datosVehiculos.get('cv').setValidators([Validators.required]);
        this.datosVehiculos.get('cv').updateValueAndValidity();
        this.calcularImpuesto();
        break;
      default:
        this.ocultar = true;
        this.datosVehiculos.controls.cv.setValue('');
        this.datosVehiculos.get('cv').clearValidators();
        this.datosVehiculos.get('cv').updateValueAndValidity();
        this.calcularImpuesto();
        break;
    }
  }

  impuestoMtriculacion(): void {
    const respuesta = this.servicio.calcularImpuesto(
      parseFloat(this.datosVehiculos.value.baseImponible),
      parseFloat(this.datosVehiculos.value.tipoImpositivo)
    );
    this.datosVehiculos.controls.impuestoMatriculacion.setValue(respuesta);
  }

  clasificaciones(): void {
    this.clasif = [
      { id: '03', descripcion: '03xx – CICLOMOTOR' },
      { id: '04', descripcion: '04xx – MOTOCICLETA' },
      { id: '06', descripcion: '06xx – AUTOMOVIL DE TRES RUEDAS' },
      { id: '10', descripcion: '10xx – TURISMO' },
      { id: '17', descripcion: '17xx – PICK UP' },
      { id: '20', descripcion: '20xx – CAMION MMA <=3.500 kg' },
      { id: '21', descripcion: '21xx – CAMION 3.500 kg. < MMA <= 12.500 kg' },
      { id: '22', descripcion: '22xx – CAMION MMA > 12.000 kg' },
      { id: '24', descripcion: '24xx – FURGON/FURGONETA MMA <= 3.500 kg' },
      { id: '31', descripcion: '31xx – VEHICULO MIXTO ADAPTABLE' },
      { id: '32', descripcion: '32xx – AUTO-CARAVANA MMA <= 3.500 kg' },
      { id: '33', descripcion: '33xx – AUTO-CARAVANA MMA > 3.500 kg' },
      { id: '66', descripcion: '66xx – QUAD ATV' },
    ];
  }
}
